import { Link, type LinkProps } from "@chakra-ui/react";
import { useSelectedNetwork } from "@umami/state";
import { compact } from "lodash";
import { type PropsWithChildren } from "react";

// Following types prevent passing both hash and id props
type OperationHashProps = {
  hash: string;
  counter?: number;
  transactionId?: never;
  originationId?: never;
  migrationId?: never;
};

type OperationIdProps = {
  hash?: never;
  counter?: never;
  transactionId?: number;
  originationId?: number;
  migrationId?: number;
};

type Props = OperationHashProps | OperationIdProps;

export const TzktLink = ({
  hash,
  counter,
  transactionId,
  originationId,
  migrationId,
  children,
  ...props
}: PropsWithChildren<Props & LinkProps>) => {
  const { explorerUrl } = useSelectedNetwork();
  let url = explorerUrl;

  if (hash) {
    url = compact([explorerUrl, hash, counter]).join("/");
  } else if (migrationId) {
    url = `${url}/migrations/${migrationId}`;
  } else if (originationId) {
    url = `${url}/originations/${originationId}`;
  } else if (transactionId) {
    url = `${url}/transactions/${transactionId}`;
  } else {
    console.warn("No id provided to TzktLink");
  }

  return (
    <Link data-testid="tzkt-link" href={url} isExternal {...props}>
      {children}
    </Link>
  );
};
